import React from "react";
import moment, { Moment } from "moment";
import { ReactComponent as CalendarSVG } from "go-core/images/svg/calendar.svg";
import { ReactComponent as CalendarDangerSVG } from "../../../../../../../images/svg/subscriptions/calendar-danger.svg";
import { SubscriptionApi } from "../../../../../../../services/Api/Subscription/subscriptionTypes";

interface Props {
	subscriptions: SubscriptionApi[];
	className?: string;
}

const SubscriptionsExpirationDate = ({ subscriptions, className }: Props) => {
	if (subscriptions.length === 0) return <></>;

	const getTheMostDistantSubscriptionDate = () => {
		const expiresDates: Moment[] = [];

		subscriptions.forEach((subscription) => {
			if (subscription.expires_at) expiresDates.push(moment(subscription.expires_at));
		});

		return moment.max(expiresDates);
	};

	const getFormattedDate = () => {
		return moment(getTheMostDistantSubscriptionDate()).format("DD.MM.YYYY");
	};

	const isExpired = () => {
		const expirationDate = getTheMostDistantSubscriptionDate();

		return moment().isAfter(expirationDate);
	};

	return (
		<div className={`d-flex align-items-center gap-2 ${className ?? ""}`}>
			{isExpired() ? <CalendarDangerSVG className="calendar-icon" /> : <CalendarSVG className="calendar-icon" />}
			<div className="d-flex align-items-center font-weight-bold">
				<p className={`${isExpired() ? "text-danger" : "text-muted"} mb-0`}>
					{isExpired() ? "Wygasła:" : "Wygaśnie:"}
				</p>
				<p className={`${isExpired() ? "text-danger" : ""} mb-0 ms-1`}>{getFormattedDate()}</p>
			</div>
		</div>
	);
};

export default SubscriptionsExpirationDate;
